var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteIcon = function SvgDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.013 5.736c-.06-.554.344-1.003.888-1.003h8.196c.55 0 .95.441.89 1.003l-.864 8.26c-.058.555-.559 1.004-1.104 1.004h-6.02a1.135 1.135 0 0 1-1.107-1.003z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    strokeLinecap: "round",
    d: "M.5 1.4h11"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1.867,
    x: 4,
    fill: "#979797",
    rx: 0.933
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#979797",
    d: "M7.5 4.733V15M10.5 4.733V15"
  }))));
};
export default SvgDeleteIcon;